import { css } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { CanvasComponent } from "./CanvasComponent";

/** CSS affecting the {@link } */
const styles: string = css`
    :host {
        margin: 0;
        padding: 0;
        background-color: #000;
        color: #fff;
        font-family: 'Arial', sans-serif;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
    }

    .game-over-container {
        text-align: center;
        opacity: 0;
        transform: scale(0.8);
        animation: fadeIn 0.5s ease-out forwards;
    }

    @keyframes fadeIn {
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .game-over-title {
        font-size: 5rem;
        color: #ff0000;
        text-shadow: 0 0 10px #ff0000, 0 0 20px #ff0000;
        margin-bottom: 2rem;
        letter-spacing: 3px;
    }

    .death-message {
        font-size: 1.8rem;
        margin-bottom: 3rem;
        max-width: 600px;
        line-height: 1.5;
    }

    .button-container {
        display: flex;
        justify-content: center;
        gap: 2rem;
    }

    .game-button {
        padding: 1rem 2rem;
        font-size: 1.2rem;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 1px;
    }

    .new-game {
        background-color: #4CAF50;
        color: white;
    }

    .new-game:hover {
        background-color: #45a049;
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(76, 175, 80, 0.4);
    }

    .restart {
        background-color: #f44336;
        color: white;
    }

    .restart:hover {
        background-color: #d32f2f;
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(244, 67, 54, 0.4);
    }

    /* Optional: Add some subtle animation to the background */
    body::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.9) 100%);
        z-index: -1;
        animation: pulse 5s infinite alternate;
    }

    @keyframes pulse {
        from {
            opacity: 0.3;
        }
        to {
            opacity: 0.9;
        }
    }
    .checkpoint {
        background-color: #2196F3;
        color: white;
    }

    .checkpoint:hover {
        background-color: #0b7dda;
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(33, 150, 243, 0.4);
    }

    .button-container {
        display: flex;
        justify-content: center;
        gap: 1rem;
        flex-wrap: wrap;
    }
`;

export class GameOverComponent extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();
    private readonly _gameEventService: GameEventService = new GameEventService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.soundController();
        void this.render();
    }

    private async render(): Promise<void> {
        if (!this.shadowRoot) return;

        // Check if checkpoint exists
        // const hasCheckpoint: boolean = localStorage.getItem("lastCheckpoint") !== null;

        this.shadowRoot.innerHTML = `
        <style>${styles}</style>
        <div class="game-over-container">
            <h1 class="game-over-title">Game Over</h1>
            <p class="death-message" id="death-message">${await this.getDeathMessage()}</p>
            <div class="button-container">
                <button class="game-button exit">Title Menu</button>
                
                <button class="game-button restart">Restart Game</button>
            </div>
        </div>
        `;

        // ${hasCheckpoint ? "<button class='game-button checkpoint'>Last Checkpoint</button>" : "<button class='game-button checkpoint' disabled>Last Checkpoint</button>"}

        this.loadEventListeners();
    }

    private soundController(): void {
        this._gameEventService.StopAudio();
        this._gameEventService.playSound("boom.mp3");
    }

    private loadEventListeners(): void {
        const newGameBtn: HTMLButtonElement = this.shadowRoot!.querySelector(".exit") as HTMLButtonElement;
        const restartGameBtn: HTMLButtonElement = this.shadowRoot!.querySelector(".restart") as HTMLButtonElement;
        // const checkpointBtn: HTMLButtonElement = this.shadowRoot!.querySelector(".checkpoint") as HTMLButtonElement;

        newGameBtn.addEventListener("click", async () => {
            await this._gameRouteService.exitGame();
            this.refreshGameState();
        });

        restartGameBtn.addEventListener("click", async () => {
            await this._gameRouteService.restartGame();
            // this.clearCheckpoint(); // Clear checkpoint on full restart
            this.refreshGameState();
        });

        // checkpointBtn.addEventListener("click", async () => {
        //     await this.loadFromCheckpoint();
        //     // change playersession states e.g. isfightseabeast = false;
        //     this.refreshGameState();
        // });
    }

    // private async loadFromCheckpoint(): Promise<void> {
    //     const checkpoint: string | null = localStorage.getItem("lastCheckpoint");
    //     if (checkpoint) {
    //         await this._gameRouteService.loadCheckpoint(checkpoint);
    //     }
    // }

    // private clearCheckpoint(): void {
    //     localStorage.removeItem("lastCheckpoint");
    // }

    private async getDeathMessage(): Promise<string> {
        const deathMessageNumber: number = await this._gameRouteService.getDeathMessage();
        return this.loadDeathMessage(deathMessageNumber);
    }

    private loadDeathMessage(deathMessageNumber: number): string {
        switch (deathMessageNumber) {
            case 1:
                return "You died eating eating suspicious food you found in an unknown jungle... thats just dumb.";
            case 2:
                return "you dead dumbah";
            case 3:
                return "Never fight something bigger than you..";
        }
        return "Better luck next time";
    }

    private refreshGameState(): void {
        const canvasComponent: CanvasComponent | null = document.querySelector("game-root");

        if (canvasComponent && canvasComponent.shadowRoot) {
            const gameCanvas: HTMLElement | null = canvasComponent.shadowRoot.querySelector("game-canvas");
            if (gameCanvas) {
                void (gameCanvas as CanvasComponent).refreshGameState();
            }
        }
    }
}
